import moment from "moment";
import React from "react";

function formatDate(inputDate) {
  const date = new Date(inputDate);
  const options = {
    month: "long",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true
  };
  return date.toLocaleDateString("en-US", options);
}

function CustomDateFormatter({ date }) {
  const newDate = moment.utc(date);
  const localDate = newDate.local().toDate();
  const formattedDate = formatDate(localDate);
  return <span>{formattedDate}</span>;
}

export default CustomDateFormatter;
